import { FC, PropsWithChildren } from 'react'

export const TopBar: FC<PropsWithChildren> = ({ children }) => (
  <div className="w-screen min-w-256 bg-white dark:bg-gray-700 px-4 border-b border-primary-50 dark:border-gray-600 ">
    <nav className="h-11 flex items-center justify-between relative">{children}</nav>
  </div>
)
